import apiCarHiddenFields from '../../api/apiCarHiddenFields'
import apiUsers from '../../api/apiUsers'

const state = {
    data: {
        id: null,
        user_id: null,
        car_id: null,
        name: null
    },
    fields: [],
    user: null,
    currentUserCarHiddenFields: localStorage.getItem('userCarHiddenFields') ? JSON.parse(localStorage.getItem('userCarHiddenFields')) : []
}

const getters = {
    getCarHiddenFieldData: (state) => {
        return state.data
    },
    getCarHiddenFields: (state) => {
        return state.fields
    },
    getCarHiddenFieldsUser: (state) => {
        return state.user
    },
    getUserCarHiddenFieldsResultPriceStatus: (state) => {
        let hasField = false

        if (state.user !== null) {
            state.user.car_hidden_fields.map(object => {
                if (object.name === "result_price") {
                    hasField = true
                }
            })
        }

        return hasField
    },
    checkIfCurrentUserCarColumnIsHidden: (state) => (column) => {
        let isNotHidden = true

        state.currentUserCarHiddenFields.map(object => {
            if (object.name === column) {
                isNotHidden = false
            }
        })

        return isNotHidden
    },
    getUserCarHiddenFieldsResultPriceId: (state) => {

        let fieldId = null;

        if (state.user !== null) {
            state.user.car_hidden_fields.map(object => {
                if (object.name === "result_price") {
                    fieldId = object.id
                }
            })
        }

        return fieldId
    }
}

const mutations = {
    changeCarHiddenFieldData: (state, data) => {
        state.data = data
    },
    changeCarHiddenFields: (state, data) => {
        state.fields = data
    },
    changeCarHiddenFieldsUser: (state, data) => {
        state.user = data
    },
    changeCarHiddenFieldDataToDefault: (state) => {
        state.data = {
            id: null,
            user_id: null,
            name: null
        }
    },
    changeCurrentUserCarHiddenFields: (state, data) => {
        localStorage.setItem("userCarHiddenFields", JSON.stringify(data))
        state.currentUserCarHiddenFields = data

    }
}

const actions = {
    setCarHiddenFieldData: ({ commit }, data) => {
        commit('changeCarHiddenFieldData', data)
    },
    setCarHiddenFields: ({ commit }, data) => {
        commit('changeCarHiddenFields', data)
    },
    setCurrentUserCarHiddenFields: ({ commit }, data) => {
        commit('changeCurrentUserCarHiddenFields', data)
    },
    createCarHiddenField: ({ dispatch, state }) => {
        dispatch('setStatusLoading')
        apiCarHiddenFields
            .createCarHiddenFieldRequest(state.data)
            .then(response => {
                if (response.data.user_id != null) {
                    dispatch('fetchUserWithCarHiddenFields', response.data.user_id)
                }

                if(response.data.car_id != null) {
                    dispatch('setStatusLoaded')
                    location.reload();
                }
            })
            .catch(error => {
                dispatch('setStatusLoaded')
                console.log(error)
            })
    },
    deleteUserCarHiddenField: ({ commit, dispatch }, data) => {
        dispatch('setStatusLoading')
        apiCarHiddenFields
            .deleteCarHiddenFieldRequest(data.fieldId)
            .then(response => {
                if (data.userId != null) {
                    dispatch('fetchUserWithCarHiddenFields', data.userId)
                }

                if(data.carId != null) {
                    dispatch('setStatusLoaded')
                    location.reload();
                }
            })
            .catch(error => {
                console.log(error)
                dispatch('setStatusLoaded')
            })
    },
    fetchUserWithCarHiddenFields: ({ commit, dispatch }, userId) => {
        dispatch('setStatusLoading')
        apiUsers
            .userRequest(userId)
            .then(result => {
                commit('changeCarHiddenFieldsUser', result.data)
                dispatch('setStatusLoaded')
            })
            .catch(error => {
                console.log(error)
                dispatch('setStatusLoaded')
            })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/carHiddenFields.js